import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";

const ConfirmDialog = ({
  open,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  items = [],
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColor = "error", // "error" | "primary" | "warning"
  onConfirm,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2, py: 1 },
      }}
    >
      <DialogTitle sx={{ fontWeight: 600, textTransform: "uppercase" }}>
        {title}
      </DialogTitle>

      <DialogContent>
        <Typography variant="body" sx={{ mb: items.length ? 1 : 0 }}>
          {message}
        </Typography>

        {items.length > 0 && (
          <Box
            sx={{
              maxHeight: 100,
              overflowY: "auto",
              py: 1,
              borderRadius: 1,
              bgcolor: "#fafafa",
              mt: 1,
            }}
          >
            <Typography variant="note" color="text.secondary">
              {items.join(", ")}
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined" color="inherit">
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color={confirmColor}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
